import { CaptureCountlyEvents, CaptureCountlyEventsContext } from 'contexts/capture-countly-events';
import { useContext } from 'react';

const useCaptureCountlyEvent = (): CaptureCountlyEvents => {
    const context = useContext(CaptureCountlyEventsContext);

    if (context === undefined) {
        throw new Error('useCaptureCountlyEvent must be used within a CaptureCountlyEventsContextProvider');
    }

    return context;
};

export { useCaptureCountlyEvent };
